export enum FormType {
  Create = "Create",
  Edit = "Edit",
}
